import "./custom_link.scss";

export const CustomLink = ({ text, onClick }) => {
    return (
        <div className="default-heading link-container clickable" onClick={() => onClick()}>
            <h3 className="link-text">{text}</h3>
        </div>
    );
};
